<template>
  <div id="zoomed-gallery" class="pdp-product-image-zoom">
    <swiper ref="slider" :options="swiperOptions">
      <swiper-slide v-for="(item, index) in items" :key="`${item.data.assetId}-${index}`">
        <img :data-srcset="getSrcSet(item.data.assetId)" class="swiper-lazy" />
        <div v-if="item.data.isAccessorized" class="accessories-disclaimer">
          <span v-if="productType === 'bike'" v-html="bp('accessorizedCaption')" />
          <span v-else v-html="bp('accessorizedAftermarketCaption')" />
        </div>
      </swiper-slide>
      <div slot="button-prev" class="swiper-button-prev"></div>
      <div slot="button-next" class="swiper-button-next"></div>
      <div v-if="items.length > 1" slot="pagination" class="swiper-pagination"></div>
    </swiper>
    <trek-button
      text
      icon-only
      large
      icon="close"
      class="pdp-product-image-zoom__close-button"
      :aria-label="bp('closeZoom')"
      @click="close"
    />
  </div>
</template>
<script>
import {ProductImages} from '@/components/containers/pdp/utils/product-images';
import {swiper, swiperSlide} from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import TrekButton from '@/components/TrekButton';

export default {
  name: 'PdpProductImageZoom',
  components: {
    swiper,
    swiperSlide,
    TrekButton,
  },
  props: {
    productType: {
      type: String,
      default: '',
    },
    images: {
      type: Array,
      default: () => [],
    },
    currentImageIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      currentSlide: 0,
      swiperOptions: {
        preloadImages: false,
        lazy: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    };
  },
  computed: {
    items() {
      return this.images.filter((item) => item.type !== 'video');
    },
    swiper() {
      return this.$refs.slider.swiper;
    },
  },
  watch: {
    currentSlide(value) {
      this.swiper.slideTo(value);
    },
  },
  mounted() {
    this.startListeningKeyboard();
    this.currentSlide = this.currentImageIndex;
  },
  beforeDestroy() {
    this.stopListeningKeyboard();
  },
  methods: {
    getSrcSet: (assetId, options = {}) => ProductImages.getSrcSet(assetId, options),
    startListeningKeyboard() {
      this.stopListeningKeyboard();
      document.addEventListener('keydown', this.keyPressed);
    },
    stopListeningKeyboard() {
      document.removeEventListener('keydown', this.keyPressed);
    },
    keyPressed(ev) {
      let nextItemIndex = this.currentSlide;
      if (ev.keyCode === 37) {
        nextItemIndex--;
      } else if (ev.keyCode === 39) {
        nextItemIndex++;
      }

      if (nextItemIndex < 0) {
        nextItemIndex = this.items.length - 1;
      } else if (nextItemIndex >= this.items.length) {
        nextItemIndex = 0;
      }

      this.currentSlide = nextItemIndex;
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>
<style lang="scss" scoped>
.pdp-product-image-zoom {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;

  .swiper-slide {
    display: block;
    position: relative;
    width: 100vw;
    height: 100vh;

    img {
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      position: absolute;
      padding-left: 10vw;
      padding-right: 10vw;
    }
  }
}

.pdp-product-image-zoom__close-button {
  position: absolute;
  z-index: 2;
  top: 1.5rem;
  right: 1.5rem;
  color: var(--gray-20);
}
</style>
